export const API_BASE_URI = process.env.REACT_APP_API_URI
export const DWOLLA_ENVIRONMENT = process.env.REACT_APP_DWOLLA_ENVIRONMENT